import { defineMessages } from 'react-intl';

const messages = defineMessages({
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  widgetInfo: {
    id: 'PxD+NP',
    defaultMessage:
      'IBM offers flexible pricing options and volume discounts. Request a quote unique to your needs.',
  },
  widgetText_1: {
    id: 'uF1UIh',
    defaultMessage:
      'Estimate your discounted IBM Instana price based on the scope of your needs',
  },
  inlineTextTitleLicense: {
    id: 'L7iaLt',
    defaultMessage: 'Software subscription license information',
  },
  inlineTextLicense: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  inlineTextTitleSaaS: {
    id: 'pzhawg',
    defaultMessage: 'Software as a Service information',
  },
  inlineTextSaaS: {
    id: 'rmewhl',
    defaultMessage:
      'All the benefits of the IBM Instana platform without the need to invest in hardware or infrastructure.',
  },
  productToAcquire: {
    id: '9ky+23',
    defaultMessage: 'Product to acquire:',
  },
  productToAcquireHeadTooltip: {
    id: 'K5KS8K',
    defaultMessage: 'Product to acquire',
  },
  productToAcquireDescTooltip: {
    id: 'PM69bu',
    defaultMessage:
      'Please select the run mode of the product as SaaS or software (on-premises).',
  },
  invalidVmText_1: {
    id: 'hrFfVj',
    defaultMessage: 'Maximum to process ',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'zSj5Ir',
    defaultMessage: 'Minimum to process ',
  },
  invalidVmText_4: {
    id: '6c9u6e',
    defaultMessage: 'Minimum purchase of either Standard or Essentials is ',
  },
  hosts: {
    id: '1enrwL',
    defaultMessage: ' MVSs.',
  },
  numberOfAPMHostsLabel: {
    id: 'hLMzk7',
    defaultMessage: 'Number of Standard MVSs:',
  },
  numberOfAPMHostsTooltip: {
    id: 'kF7KMI',
    defaultMessage: 'Number of Application Performance Managment MVSs',
  },
  numberOfAPMHostsDescTooltip: {
    id: 'ZyCtYN',
    defaultMessage:
      'Please move the slider to indicate the number of Standard MVS machines you would like to include in your estimate.',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  numberOfAPMHostsLabelTitle: {
    id: '/e6QG8',
    defaultMessage: 'Application Performance Management MVSs',
  },
  numberOfIQMHostsLabelTitle: {
    id: 'lhgurE',
    defaultMessage: 'Infrastructure Quality Management MVSs',
  },
  oneYearEstimatedCosts: {
    id: '7U4yNh',
    defaultMessage: '1 Year estimated price',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  numberIQMHostsLabel: {
    id: '71QbFs',
    defaultMessage: 'Number of Essentials MVSs:',
  },
  numberIQMHostsHeadTooltip: {
    id: 'DmG53j',
    defaultMessage: 'Number of Infrastructure Quality Management MVSs',
  },
  numberIQMHostsDescTooltip: {
    id: 'eFdBlj',
    defaultMessage:
      'Please move the slider to indicate the number of Essentials you would like to include in your estimate.',
  },
  footnoteOne: {
    id: 'K8x5Sd',
    defaultMessage:
      'Minimum service term is 12 months. Actual environmental costs and performance characteristics will vary depending on individual client configurations and conditions, including but not limited to, add-ons and discounts. Your quoted price may vary. Local pricing may vary by country. Generally expected results cannot be provided as each client’s results will depend entirely on the client’s systems and services ordered. IBM Business Partners set their own prices, which may vary.',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  contactInfo2: {
    id: 'JAWq87',
    defaultMessage: 'For a solution this size, please contact us',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  estimatedCosts: {
    id: 'YBINwe',
    defaultMessage: 'Estimated price',
  },
  calculationMessage: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  asteriskPrice: {
    id: 'ftAYAF',
    defaultMessage:
      'Estimates, including currency OR pricing references which exclude applicable taxes, are current as of the initial date of publication and may be changed by IBM at any time and without notice. Local pricing may vary by country. Only applicable for new Instana clients with initial purchase. Additional volume discount may be available. ',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  getROIButton: {
    id: 'FO1Qyz',
    defaultMessage: 'View IBM Instana benefits',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: 'RKK2FB',
    defaultMessage: 'The Instana estimator is available in',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  columnOneTilte: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  columnTwoTilte: {
    id: 'nXJg2u',
    defaultMessage: 'MVSs',
  },
  feedBackText: {
    id: 'XvuIXj',
    defaultMessage: 'Is this helpful:',
  },
  feddbackPhraseText: {
    id: 'yI2J2z',
    defaultMessage:
      'Please provide your thoughts about what we can do to better?',
  },
  feedbackComment: {
    id: '4FQrdH',
    defaultMessage: 'Comment:',
  },
  feedbackCommentHolder: {
    id: '6jv80B',
    defaultMessage: 'Your comments here...',
  },
  feedbackHeaderText: {
    id: 'qxui/f',
    defaultMessage: 'Feedback form',
  },
  feedbackInvalidMaximum: {
    id: '+uPBEM',
    defaultMessage: 'Maximum number of characters to process',
  },
  feedbackInvalidMinimum: {
    id: 'fkJa3C',
    defaultMessage: 'Minimum number of characters to process',
  },
  feedbackEmail: {
    id: 'zuu8pi',
    defaultMessage: 'Email (optional):',
  },
  feedbackEmailHolder: {
    id: 'Q75vbh',
    defaultMessage: 'Example: yourEmail@ibm.com',
  },
  feedbackInvalidEmail: {
    id: 'HBERi+',
    defaultMessage: 'Invalid email.',
  },
  feedbackCharacters: {
    id: '0Bc7rz',
    defaultMessage: 'Characters.',
  },
  feedbackCancel: {
    id: '47FYwb',
    defaultMessage: 'Cancel',
  },
  feedbackSubmit: {
    id: 'wSZR47',
    defaultMessage: 'Submit',
  },
  feedback203: {
    id: '7FTPXh',
    defaultMessage: 'Sorry, I could sent the feedback!',
  },
  feedback200: {
    id: 'FxvkF9',
    defaultMessage: 'Thank you! Your feedback was sent',
  },
  feedBackHelpfull: {
    id: '5vwKkg',
    defaultMessage: 'Helpful',
  },
  feedBackNotHelpfull: {
    id: '04tuTF',
    defaultMessage: 'Not helpful',
  },
  feedback500: {
    id: '4XFlJg',
    defaultMessage: 'Thank you, but something went wrong!',
  },
  modalResponseText: {
    id: 'MgdnPi',
    defaultMessage: 'Response',
  },
  modalContinue: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  getQuoteButton2: {
    id: 'DXQb1r',
    defaultMessage: 'Get your best price',
  },
  //
});

export default messages;
